export default "__VITE_ASSET__6wNbNqv3__"